<template>
  <div class="certificate" ref="certBody">
    <div class="certificate-cert">
      <div class="certificate-cert__upper">
        <div class="certificate-cert__upper-left">
          <div class="certificate__proudly">
            <div class="certificate__proudly-pill">CERTIFICATION</div>
            <div class="certificate__proudly-label">Proudly presented to</div>
          </div>
          <h1 class="certificate__username">
            {{ fullName }}
          </h1>
          <div class="certificate__type-wrapper">
            <h3 class="certificate__title">
              {{ certificate.certification_name }}
            </h3>
          </div>
        </div>
        <div class="certificate-cert__upper-right">
          <div class="certificate__badge">
            <img
              src="@/assets/images/certification/ine-badge.png"
              :alt="`${certificate.certification_name} badge`"
            />
          </div>
        </div>
      </div>
      <div class="certificate-cert__middle">
        <div class="certificate__details">
          <div class="certificate__details-field-qr" ref="qrcode"></div>
          <div class="certificate__details-field-wrapper">
            <div class="certificate__details-field">
              <div class="certificate__details-subtitle">Version</div>
              <div class="certificate__details-data">
                V{{ certificate.exam_version }}
              </div>
            </div>
            <div class="certificate__details-field">
              <div class="certificate__details-subtitle">Date awarded</div>
              <div class="certificate__details-data">
                {{ awardedAt }}
              </div>
            </div>
            <div class="certificate__details-field">
              <div class="certificate__details-subtitle">Certification ID</div>
              <div class="certificate__details-data">#{{ shortenUUID }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="certificate__signatures">
        <div class="certificate__signature">
          <div>
            <img
              class="certificate__signature-img"
              src="@/assets/images/certification/dw-signature.png"
              alt="Dara Warn signature"
            />
          </div>
          <div class="certificate__signature-name-wrapper">
            <div class="certificate__signature-name">Dara Warn</div>
            <div class="certificate__signature-position">
              Chief Executive Officer
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="certificate__logo-container">
      <img
        class="certificate__logo"
        src="@/assets/images/certification/ine_logo.png"
        alt="INE Logo"
      />
    </div>
  </div>
</template>

<script>
import QRCodeStyling from 'qr-code-styling'
import { textDate } from '@/helpers'

export default {
  name: 'INECertificationTemplate',
  props: {
    certificate: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      qrCode: null,
    }
  },
  computed: {
    fullName() {
      return `${this.certificate.first_name} ${this.certificate.last_name}`
    },
    awardedAt() {
      return textDate(this.certificate.finished_at)
    },
    shortenUUID() {
      return this.certificate.attempt_id
        ? this.certificate.attempt_id.split('-')[0]
        : ''
    },
    certificateURL() {
      return `${window.location.origin}/certificate/${this.certificate.attempt_id}`
    },
  },
  methods: {},
  async mounted() {
    const options = {
      width: 148,
      height: 148,
      type: 'svg',
      data: `${this.certificateURL}`,
      margin: 0,
      qrOptions: {
        typeNumber: '0',
        mode: 'Byte',
        errorCorrectionLevel: 'M',
      },
      imageOptions: {
        hideBackgroundDots: true,
        imageSize: 0.8,
        margin: 4,
      },
      dotsOptions: {
        type: 'rounded',
        color: '#6a1a4c',
        gradient: {
          type: 'linear',
          rotation: 4.9,
          colorStops: [
            {
              offset: 0,
              color: '#E37C3A',
            },
            {
              offset: 1,
              color: '#DB4133',
            },
          ],
        },
      },
      backgroundOptions: {
        color: '#ffffff',
      },
      image: require('@/assets/images/certification/ine-qr-icon.png'),
      dotsOptionsHelper: {
        colorType: {
          single: true,
          gradient: false,
        },
        gradient: {
          linear: true,
          radial: false,
          color1: '#6a1a4c',
          color2: '#6a1a4c',
          rotation: '0',
        },
      },
      cornersSquareOptions: {
        type: 'square',
        color: '#e10321',
        gradient: null,
      },
      cornersSquareOptionsHelper: {
        colorType: {
          single: true,
          gradient: false,
        },
        gradient: {
          linear: true,
          radial: false,
          color1: '#000000',
          color2: '#000000',
          rotation: '0',
        },
      },
      cornersDotOptions: {
        type: 'square',
        color: '#e10321',
      },
      cornersDotOptionsHelper: {
        colorType: {
          single: true,
          gradient: false,
        },
        gradient: {
          linear: true,
          radial: false,
          color1: '#000000',
          color2: '#000000',
          rotation: '0',
        },
      },
      backgroundOptionsHelper: {
        colorType: {
          single: true,
          gradient: false,
        },
        gradient: {
          linear: true,
          radial: false,
          color1: '#ffffff',
          color2: '#ffffff',
          rotation: '0',
        },
      },
    }
    // Create new QRCode Object
    this.qrCode = new QRCodeStyling(options)
    this.qrCode.append(this.$refs.qrcode)
  },
}
</script>

<style lang="scss" scoped>
.certificate {
  padding: 0;
  color: var(--white);
  position: relative;

  height: 100%;
  z-index: 1000;
  display: flex;
  flex-direction: column;

  color: var(--aubergine);
  background: var(--white);

  background-image: url('../../assets/images/certification/ine-badge-background.png');
  background-repeat: no-repeat;
  background-position-y: -1px;
  background-position-x: right;

  width: 335px;
  background-size: 161px 181px;
  margin-bottom: 10px;

  position: relative;

  @include mobile {
    width: 725px;
    height: 565px;
    background-size: 380px 420px;
    margin-bottom: 15px;
  }

  @include tablet {
    width: 1073px;
    max-width: calc(100vw - 50px);
    height: 800px;
    background-size: 521px 590px;
    margin-bottom: 20px;
  }
  &__badge {
    height: 81px;
    position: absolute;
    right: 0;
    top: -15px;
    @include mobile {
      width: 127px;
      height: 167px;
      top: -15px;
      right: 12%;
    }
    @include tablet {
      width: 193px;
      height: 252px;
      top: -15px;
      right: 5%;
    }
    img {
      height: 100%;
    }
  }

  &__badge:after {
    content: '';
    width: 15px;
    height: 15px;
    position: absolute;
    top: 50%;
    left: 50%;
    box-shadow: -1px 1px 100px 60px rgb(51 51 51 / 50%);
    border-radius: 50%;

    @include mobile {
      width: 30px;
      height: 30px;
      box-shadow: -1px 1px 150px 120px rgb(51 51 51 / 50%);
    }
  }
  &__type-wrapper {
    display: flex;
    justify-content: flex-start;
    gap: 40px;
  }
  &__title {
    font-weight: bold;
    font-size: rem(11);
    line-height: rem(12);
    color: var(--auberigne);
    font-family: var(--font-bold);
    margin: 0 0 8px 0;
    width: fit-content;

    @include mobile {
      font-size: rem(21);
      line-height: rem(24);
      margin-bottom: 17px;
    }

    @include tablet {
      font-size: rem(33);
      line-height: rem(41);
      margin: 0 0 15px 0;
    }
  }
  &__username {
    margin: 0 0 16px 0;
    font-weight: bold;
    font-size: rem(16);
    font-family: var(--font-bold);
    font-weight: 900;
    color: var(--aubergine);
    line-height: 12px;
    max-width: 150px;
    height: 38px;
    @include mobile {
      width: 100%;
      height: 76.5px;
      max-width: 309px;
      margin: 0 0 34px 0;
      font-size: rem(33);
      line-height: 44px;
    }

    @include tablet {
      font-size: rem(49);
      line-height: rem(52);
      margin: 25px 0 52px 0;
      width: 100%;
      height: 117px;
      max-width: 562px;
    }

    &-certification {
      background: var(--red-gradient);
      border-radius: 20px;
      font-size: rem(8);
      padding: 3px 7px;
      color: var(--white);

      @include mobile {
        border-radius: 20px;
        font-size: rem(12);
        padding: 5px 15px;
      }
    }
  }
  &__proudly {
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 8px;
    @include mobile {
      margin-bottom: 16.5px;
    }
    @include tablet {
      margin-bottom: 0;
    }
    &-pill {
      position: relative;
      left: -3px;
      font-size: rem(5);
      line-height: rem(6);
      width: fit-content;
      padding: 3px 6px;
      color: var(--white);
      background: var(--orangest-horizontal-gradient);
      border-radius: 20px;
      @include mobile {
        left: -10px;
        font-size: rem(12);
        line-height: 14px;
        padding: 6px 12px;
      }
      @include tablet {
        left: -12px;
        font-size: rem(14);
        line-height: 16px;
        padding: 8px 18px;
      }
    }
    &-label {
      color: var(--gray-lavender);
      font-size: rem(7);
      line-height: rem(7);
      @include mobile {
        font-size: rem(16);
      }
    }
  }
  &-cert {
    margin: 40px 32px;
    display: flex;
    flex-direction: column;
    position: relative;
    @include mobile {
      margin: 82px 25px 25px 82px;
      max-height: 550px;
    }

    @include tablet {
      margin: 100px 80px;
      max-height: unset;
    }

    &__upper {
      display: flex;
      flex-direction: row;
      width: 290px;

      @include mobile {
        width: 600px;
      }
      @include tablet {
        width: 870px;
      }
      &-left {
        width: 100%;
      }
    }

    &__middle {
      max-height: 75px;
      @include mobile {
        max-height: unset;
      }
    }
  }
  &:before {
    content: '';
    background: var(--orangest-vertical-gradient);
    position: absolute;
    top: 40%;
    height: 54px;
    width: 3px;

    @include mobile {
      top: 42%;
      height: 150px;
      width: 7px;
    }

    @include tablet {
      top: 42%;
      height: 194px;
      width: 10px;
    }
  }

  &__details {
    display: flex;
    max-height: 56px;
    margin-bottom: 19px;
    @include mobile {
      margin-bottom: 0;
      max-height: 110px;
    }
    @include tablet {
      max-height: 150px;
    }

    &-field {
      display: flex;
      font-size: rem(7);
      line-height: 9px;
      flex-flow: column-reverse;
      @include mobile {
        font-size: rem(12);
        line-height: 15px;
        flex-flow: column-reverse;
      }
      @include tablet {
        font-size: rem(14);
        line-height: 18px;
        flex-flow: column-reverse;
      }

      &-qr {
        transform: translateY(-32%) translatex(-30%) scale(0.37);
        max-width: 55px;
        @include mobile {
          transform: translateY(-12%) translatex(-13%) scale(0.72);
          max-width: 110px;
        }
        @include tablet {
          transform: unset;
          max-width: unset;
        }
      }

      &-wrapper {
        display: flex;
        flex-direction: column;
        margin-left: 8px;
        justify-content: space-between;
        @include mobile {
          margin-left: rem(14);
        }
        @include tablet {
          margin-left: rem(34);
        }
      }
    }
    &-subtitle {
      font-size: rem(7);
      color: var(--gray-lavender);
      width: 50px;
      height: 9px;
      @include mobile {
        font-size: rem(8);
        line-height: 15px;
        height: 15px;
        width: unset;
      }
      @include tablet {
        font-size: rem(12);
      }
    }
    &-data {
      font-weight: bold;
      color: var(--aubergine);
    }
  }
  &__signatures {
    position: relative;
    display: flex;
    align-items: center;
    position: relative;
    @include mobile {
      position: static;
      margin-top: 50px;
      height: 37px;
    }

    @include tablet {
      height: 115px;

      margin-top: 63px;
    }
  }
  &__signature {
    display: flex;
    flex-direction: column;
    &-img {
      padding-bottom: 5px;
      transform: unset;
      min-width: 90px;
      max-width: 100px;
      @include mobile {
        min-width: 206px;
        max-width: 215px;
        max-height: 114px;
      }
      @include tablet {
        min-width: 206px;
        max-width: 300px;
        max-height: 114px;
      }
    }
    &-name-wrapper {
      position: absolute;
      display: flex;
      gap: 3px;
      bottom: 0;
      font-family: var(--font-bold);
      font-size: rem(7);
      width: 300px;
      @include mobile {
        font-size: rem(12);
        bottom: -15px;
      }
      @include tablet {
        font-size: rem(12);
        bottom: 12px;
      }
    }
    &-name {
      width: fit-content;
      font-weight: bold;
    }
    &-position {
      color: var(--gray-lavender);
    }
  }
  &__logo-container {
    position: absolute;
    bottom: 12px;
    right: 12px;
    line-height: 0;
    @include mobile {
      bottom: 26px;
      right: 26px;
    }
    @include tablet {
      bottom: 40px;
      right: 40px;
    }
  }
  &__logo {
    width: 40px;
    @include mobile {
      width: 80px;
    }
    @include tablet {
      width: 120px;
    }
  }
  img {
    position: relative;
    z-index: 10;
  }
}
</style>
